var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5969 6.56712L10.3769 3.34712C10.1302 3.10045 9.79023 2.96045 9.4369 2.96045H3.32357C2.59023 2.96045 1.99023 3.56045 1.99023 4.29378V13.6271C1.99023 14.3604 2.59023 14.9604 3.32357 14.9604H12.6569C13.3902 14.9604 13.9902 14.3604 13.9902 13.6271V7.51378C13.9902 7.16045 13.8502 6.82045 13.5969 6.56712ZM4.6569 5.62712H9.32357V6.96045H4.6569V5.62712ZM11.3236 12.2938H4.6569V10.9604H11.3236V12.2938ZM11.3236 9.62712H4.6569V8.29378H11.3236V9.62712Z",
    fill: "#64748D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfq);
export default __webpack_public_path__ + "static/media/rfq.673e09ef76ba19200b8709b2c7739b10.svg";
export { ForwardRef as ReactComponent };